'use client';

import { useEffect } from 'react';
import Script from 'next/script';
import { Button } from '@workspace/ui/components/button';

declare global {
    interface Window {
        Tally?: {
            loadEmbeds: () => void;
        };
    }
}

const TALLY_PROFILE_EVAL_SRC = 'https://tally.so/embed/meW7K0?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1';
const TALLY_CAREER_STUDIO_SRC = 'https://tally.so/embed/3E7DJN?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1';
const TALLY_CAREER_FORM_SRC = 'https://tally.so/embed/mR9Kjv?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1';

export function TallyProfileEvalEmbed() {
    // Tell Tally to scan the page once the script has been loaded
    useEffect(() => {
        if (typeof window !== 'undefined' && window.Tally) {
            window.Tally.loadEmbeds();
        }
    }, []);

    return (
        <>
            {/* Loads the Tally helper after hydration */}
            <Script
                src="https://tally.so/widgets/embed.js"
                strategy="afterInteractive"
            />

            {/* The iframe already contains its final props → no mismatch */}
            <iframe
                src={TALLY_PROFILE_EVAL_SRC}
                data-tally-src={TALLY_PROFILE_EVAL_SRC}
                title="GradBrew Profile Evaluation"
                loading="lazy"
                width="100%"
                height={829}
                frameBorder={0}
                marginHeight={0}
                marginWidth={0}
                className="w-full min-h-screen"
            />
        </>
    );
}
export function TallyCareerStudioEmbed() {
    // Tell Tally to scan the page once the script has been loaded
    useEffect(() => {
        if (typeof window !== 'undefined' && window.Tally) {
            window.Tally.loadEmbeds();
        }
    }, []);

    return (
        <>
            {/* Loads the Tally helper after hydration */}
            <Script
                src="https://tally.so/widgets/embed.js"
                strategy="afterInteractive"
            />

            {/* The iframe already contains its final props → no mismatch */}
            <iframe
                src={TALLY_CAREER_STUDIO_SRC}
                data-tally-src={TALLY_CAREER_STUDIO_SRC}
                title="Career Studio by GradBrew"
                loading="lazy"
                width="100%"
                height={829}
                frameBorder={0}
                marginHeight={0}
                marginWidth={0}
                className="w-full min-h-screen"
            />
        </>
    );
}
export function TallyCareerFormEmbed() {
    // Tell Tally to scan the page once the script has been loaded
    useEffect(() => {
        if (typeof window !== 'undefined' && window.Tally) {
            window.Tally.loadEmbeds();
        }
    }, []);

    return (
        <>
            {/* Loads the Tally helper after hydration */}
            <Script
                src="https://tally.so/widgets/embed.js"
                strategy="afterInteractive"
            />

            {/* The iframe already contains its final props → no mismatch */}
            <iframe
                src={TALLY_CAREER_FORM_SRC}
                data-tally-src={TALLY_CAREER_FORM_SRC}
                title="Work with GradBrew"
                loading="lazy"
                width="100%"
                height={829}
                frameBorder={0}
                marginHeight={0}
                marginWidth={0}
                className="w-full min-h-screen"
            />
        </>
    );
}

export function TallyEventsInterestButton() {
    // Tell Tally to scan the page once the script has been loaded
    useEffect(() => {
        if (typeof window !== 'undefined' && window.Tally) {
            window.Tally.loadEmbeds();
        }
    }, []);

    return (
        <>
            {/* Loads the Tally helper after hydration */}
            <Script
                src="https://tally.so/widgets/embed.js"
                strategy="afterInteractive"
            />

            {/* Button that opens the Tally form as a popup */}
            <div className="library-all_link">
                <Button
                    variant='link'
                    data-tally-open="wAX7vl"
                    data-tally-width="600"
                    data-tally-overlay="1"
                    className="link w-inline-block p-0"
                    type="button">
                    <div className="link_content-wrapper">
                        <div className="link_text">Register Interest for Upcoming Events</div>
                    </div>
                </Button>
            </div>
        </>
    );
}
